import { styled } from '@linaria/react';
import { blur, bodyFont, colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const StyledBackButton = styled.button`
  position: absolute;
  left: ${space[5]};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space[9]};
  height: ${space[8]};
  border-radius: ${layout.borderRadiusFull};
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &[data-variant='default'] {
    border: 1px solid ${semantic.border.default};
    background: ${colors.white};

    &:hover {
      background: ${semantic.bg.surfaceSubtle};
    }
  }

  &[data-variant='overlay'] {
    background: ${semantic.bg.overlayBlur};
    backdrop-filter: blur(${blur.lg});
    top: auto;
    transform: none;

    svg {
      width: ${fonts.size.xl};
      height: ${fonts.size.xl};
      color: ${colors.white};
    }

    span {
      color: ${colors.white};
    }

    &:focus-visible {
      background: ${semantic.bg.overlayBlurStrong};
      outline-color: ${colors.white};
    }

    &:disabled svg {
      color: ${semantic.icon.disabled};
    }

    &:hover:not(:disabled) {
      background: ${semantic.bg.overlayBlurStrong};
    }

    &:active:not(:disabled) {
      background: ${semantic.bg.overlayBlurStrong};
    }
  }

  &[data-has-label='true'] {
    @media (min-width: ${layout.desktopBreakpoint}) {
      width: auto;
      gap: ${space[2]};
      padding: 0 ${space[4]};
    }
  }

  &[data-variant='inline'] {
    position: static;
    transform: none;
    background: ${semantic.bg.surfaceSubtle};

    &:hover {
      background: ${semantic.bg.surfaceStrong};
    }
  }

  &:disabled {
    pointer-events: none;
    color: ${semantic.icon.disabled};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    left: ${space[8]};
  }
`;

export const BackLabel = styled.span`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: inline;
    font-family: ${bodyFont};
    font-size: ${fonts.size.sm};
    font-weight: ${fonts.weight.medium};
    line-height: 1;
    white-space: nowrap;
    color: ${colors.black};
  }
`;
